/**
 * Login
 */

// React
import React, { useState, useEffect } from "react";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { loginAction, generateOptAction, verifyOtpAction } from "./actions";

import { Store } from "../../redux/reducers";

// Selector
import { createStructuredSelector } from "reselect";
import {
  makeSelectToken,
  makeSelectLoading,
  makeSelectError
} from "./selectors";

// UI
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  TextField,
  Avatar,
  Grid,
  CircularProgress,
  Paper,
  Typography,
  Box,
  Link,
  Card,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { mdiEmailOutline, mdiKeyOutline } from "@mdi/js";
import { StylesProvider } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";

// Helper

// Type
import {
  Props,
  SelectorProps,
  Payload,
  PayloadGenerateOpt
} from "./interfaces";
import Icon from "@mdi/react";
import Label from "../parcelInventoryItems/components/label";
import RonadIcons from "../../components/iconComponent";

// Style
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    overflow: "hidden",
    userSelect: 'none',
  },
  image: {
    backgroundImage: 'url("/login.JPG")',
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  direction: {
    direction: "ltr"
  },
  icon: {
    transform: "scaleX(-1)",
    color: "#8A8A8A"
  },
  lineHeight: {
    //   verticalAlign:'center'
    lineHeight: "3"
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    width: theme.spacing(22),
    height: theme.spacing(22)
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    margin: theme.spacing(1, 0, 5),
    padding: theme.spacing(0, 12),
    textAlign: "center"
  },
  error: {
    margin: theme.spacing(2, 0, 0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  image1: {
    // transform: "translate(776px, -500px)",
    // position: "absolute",
    // clip: "rect(150px,650px,750px,150px);",

    marginTop: "-1000px",
    marginRight: "-1300px",
    opacity: "0.1"
  },
  image2: {
    // transform: "translate(-953px, 400px)",
    // position: "absolute",
    // clip: "rect(0px,650px,430px,0px);",

    marginBottom: "-1000px",
    marginLeft: "-1500px",
    opacity: "0.1"
  }
}));

function Login(props: Props) {
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [hide, setHide] = useState(true);
  const [rememberMe] = useState(true);
  useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  const handleChangeEmailAddress = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmailAddress(event.target.value);
  };

  const handleChangePassword = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPassword(event.target.value);
  };
  // should call in saga
  const onSubmit = (e: any) => {
    e.preventDefault();
    if (emailAddress.length > 0 && password.length > 0) {
      props.loginDispatch({
        emailAddress,
        password,
        rememberMe
      });
    }
  };

  const classes = useStyles();
  return (
    <>
      <StylesProvider injectFirst>
        <Grid container component="main" className={classes.root}>
          <Grid
            item
            component="div"
            // elevation={6}
            container
            justify="center"
            alignItems="center"
            style={{ backgroundColor: '#F7F7F7' }}
          >
            {/* <Avatar
                  className={classes.avatar}
                  src="/linepoly.svg"
                  variant="square"
                  imgProps={{width:'2000px'}}
              /> */}
            <img
              src="/linepoly.svg"
              width="650px"
              className={classes.image1}
            />
            <Paper
              style={{
                width: '500px',
                marginBottom: '60px',
                marginLeft: '200px',
              }}
            >
              <div className={classes.paper}>
                <Avatar
                  className={classes.avatar}
                  src="/login-logo.svg"
                  variant="square"
                />
                <Typography component="h1" variant="h6">
                  {'به پنل انبار خوش آمدید‬'}
                </Typography>

                <form className={classes.form}>
                  {
                    <>
                      <Grid
                        container
                        spacing={1}
                        alignItems="flex-end"
                        alignContent="center"
                        direction="row"
                        justify="center"
                        style={{
                          width: '100%',
                          textAlign: 'center',
                          alignItems: 'middle',
                        }}
                      >
                        <Grid item className={classes.lineHeight}>
                          <Icon
                            path={mdiEmailOutline}
                            size={1}
                            className={classes.icon}
                          />
                        </Grid>
                        <Grid item style={{ width: '70%' }}>
                          <TextField
                            variant="standard"
                            margin="normal"
                            fullWidth
                            id="email"
                            dir="rtl"
                            type="email"
                            placeholder="ایمیل"
                            name="emailAddress"
                            autoFocus
                            value={emailAddress}
                            // InputLabelProps={{
                            //     style: {
                            //         textAlign:'right',
                            //         display:'block',
                            //         right:'0',
                            //     }
                            // }}
                            // inputProps={{placeholder:'ایمیل',title:'ایمیل'}}
                            className={classes.direction}
                            onChange={handleChangeEmailAddress}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={1}
                        alignItems="flex-end"
                        alignContent="center"
                        direction="row"
                        justify="center"
                        style={{
                          width: '100%',
                          textAlign: 'center',
                          alignItems: 'middle',
                        }}
                      >
                        <Grid item className={classes.lineHeight}>
                          <Icon
                            path={mdiKeyOutline}
                            size={1}
                            className={classes.icon}
                          />
                        </Grid>
                        <Grid item style={{ width: '70%' }}>
                          <TextField
                            variant="standard"
                            margin="normal"
                            fullWidth
                            name="password"
                            placeholder="رمز عبور"
                            type={hide ? 'password' : 'text'}
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={handleChangePassword}
                            className={classes.direction}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <RonadIcons onClick={() => setHide(!hide)} name={hide ? "eye-off" : "eye"} className={classes.icon} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      </Grid>{' '}
                    </>
                  }

                  {/* {props.error && mode === "default" && (
                                      <Alert
                                      variant="filled"
                                      severity="error"
                                      className={classes.error}
                                      >
                                      ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را
                                      بررسی و دوباره امتحان نمایید
                                      </Alert>
                                    )} */}
                  {props.error == 'not-for-warehouse' ||
                    props.error == 'Request failed with status code 401' ? (
                    props.error == 'not-for-warehouse' ? (
                      <Alert
                        variant="filled"
                        severity="error"
                        className={classes.error}
                      >
                        ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و
                        دوباره امتحان نمایید
                      </Alert>
                    ) : (
                      props.error ==
                      'Request failed with status code 401' && (
                        <Alert
                          variant="filled"
                          severity="error"
                          className={classes.error}
                        >
                          لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره امتحان
                          نمایید
                        </Alert>
                      )
                    )
                  ) : (
                    props.error && (
                      <Alert
                        variant="filled"
                        severity="error"
                        className={classes.error}
                      >
                        ورود ناموفق، لطفا دوباره امتحان نمایید
                      </Alert>
                    )
                  )}

                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{
                      minWidth: '25%',
                      borderRadius: '100px',
                    }}
                    className={classes.submit}
                    onClick={e => onSubmit(e)}
                    disabled={props.loading}
                  >
                    {'ورود'}
                    {props.loading && <CircularProgress size={24} />}
                  </Button>

                  {/* {mode === "generateOpt" && (
                                      <Button
                                      type="submit"
                                      variant="contained"
                                      color="primary"
                                      style={{ minWidth: "25%" }}
                                      className={classes.submit}
                                      onClick={(e) => onSubmit(e)}
                                      disabled={phoneNumber.length === 0}
                                      >
                                      {mode === "generateOpt" && "دریافت کد"}
                                      
                                      {props.loading && (
                                          <CircularProgress size={24} />
                                          )}
                                          </Button>
                                        )} */}

                  {/* <Grid container>
                                  {mode === "default" ? (
                                      <Grid item xs>
                                      <Button
                                      onClick={() =>
                                        changeModeLogin("generateOpt")
                                    }
                                    >
                                    {" "}
                                    ورود با شماره موبایل
                                    </Button>
                                    </Grid>
                                    ) : (
                                        <Grid item xs>
                                        <Button
                                        onClick={() =>
                                            changeModeLogin("default")
                                        }
                                        >
                                        {" "}
                                        ورود با ایمیل{" "}
                                        </Button>
                                        </Grid>
                                        )}
                                    </Grid> */}
                </form>
                {/*             <Box mt={8}>
                              <Typography variant="body2" color="textSecondary" align="center">
                              {'شماره پشتیبانی '}
                              <Link color="inherit" href="tel:02153850538">
                              53850538 - 021
                              </Link>{' '}
                              </Typography>
                            </Box> */}
              </div>
            </Paper>
            <img
              src="/linepoly.svg"
              width="650px"
              className={classes.image2}
            />
          </Grid>
          {/* <Grid item xs={false} md={8} className={classes.image} /> */}
        </Grid>
      </StylesProvider>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  token: makeSelectToken(),
  loading: makeSelectLoading(),
  error: makeSelectError()
});

function mapDispatchToProps(dispatch: Function) {
  return {
    loginDispatch: (payload: Payload) => dispatch(loginAction(payload)),
    generateOptDispatch: (payload: PayloadGenerateOpt) =>
      dispatch(generateOptAction(payload)),
    verifyOptDispatch: (payload: {
      code: string;
      phoneNumber: string;
      rememberMe: boolean;
    }) => dispatch(verifyOtpAction(payload))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Login);
